import createClient from 'openapi-fetch';
import type { paths } from './schema';
import { apiBaseUrl } from './baseUrl';

export const api = createClient<paths>({ baseUrl: apiBaseUrl, credentials: 'include' });

export { apiBaseUrl };

export type HeadstoneDTO = NonNullable<
  paths['/headstones']['get']['responses']['200']['content']['application/json']
>[number];

export type MapHeadstonesResponseDTO = NonNullable<
  paths['/headstones/map']['get']['responses']['200']['content']['application/json']
>;

export type CatalogResponseDTO = NonNullable<
  paths['/headstones/catalog']['get']['responses']['200']['content']['application/json']
>;

export type CatalogEntryDTO = NonNullable<CatalogResponseDTO['inMemory']['items']>[number];

export type CheckoutResponse = NonNullable<
  paths['/payments/checkout']['post']['responses']['200']['content']['application/json']
>;

export type PostDTO = NonNullable<
  paths['/posts']['get']['responses']['200']['content']['application/json']
>['items'][number];

export type CommentDTO = NonNullable<
  paths['/posts/{id}/comments']['get']['responses']['200']['content']['application/json']
>[number];

export type PostQuotaDTO = NonNullable<
  paths['/posts/quota']['get']['responses']['200']['content']['application/json']
>[number];
